import React from 'react';
import { OfferCard } from './OfferCard';
export function FinalCTA() {
  return <section className="py-16 sm:py-24 bg-slate-900 text-white relative overflow-hidden" data-id="element-63">
      <div className="absolute inset-0 bg-brand-500/10" data-id="element-64" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-brand-500/20 blur-[100px] rounded-full" data-id="element-65" />

      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-66">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight mb-4 sm:mb-6 text-balance" data-id="element-67">
          STOP PLANNING FROM SCRATCH EVERY WEEK.
        </h2>
        <p className="text-base sm:text-xl text-slate-300 mb-8 sm:mb-12 max-w-2xl mx-auto text-balance" data-id="element-68">
          Stretching Ready gives you the complete system to prepare classes in
          minutes and teach with the professionalism your students deserve. Less
          time staring at a blank page — more time doing what you love.
        </p>

        <OfferCard variant="full" data-id="element-69" />
      </div>
    </section>;
}